import { MS_PER_PIXEL } from "@/lib/timeline/book/BookLayout";
import {
  groupRiseAboveRail,
  markerCircleRadius,
  seatOnCircle,
} from "../../marker/MarkerMetrics/circleRadius";
import { MARKER_CIRCLE_RADIUS } from "../../marker/MarkerMetrics/metrics";

/** Rest position: marker group center near the left end of the axis rail. */
export function timelineHomeMarkerCenterX(viewportWidth: number): number {
  const inset = Math.max(120, viewportWidth * 0.12);
  const spread = MARKER_CIRCLE_RADIUS * 2 + 48;
  return inset + spread / 2;
}

export interface SceneMotionFrame {
  gridScrollPx: number;
  groupCenterX: number;
}

/**
 * Travel left → right along the rail. Distance is scene length on the time
 * scale (`MS_PER_PIXEL`), so later locations sit further down the line.
 */
export function computeSceneMotion(
  playheadMs: number,
  viewportWidth: number,
  totalDurationMs: number,
): SceneMotionFrame {
  const durationMs = Math.max(1, totalDurationMs);
  const playhead = Math.min(durationMs, Math.max(0, playheadMs));
  const startX = timelineHomeMarkerCenterX(viewportWidth);
  const groupCenterX = startX + playhead / MS_PER_PIXEL;
  const gridScrollPx = -startX;
  return { groupCenterX, gridScrollPx };
}

export interface MarkerCircleOffset {
  dx: number;
  dy: number;
}

export function markerCircleOffset(
  index: number,
  characterCount: number,
): MarkerCircleOffset {
  if (characterCount <= 0) {
    return { dx: 0, dy: 0 };
  }
  const rise = groupRiseAboveRail(characterCount);
  if (characterCount === 1) {
    return { dx: 0, dy: -rise };
  }
  const seat = seatOnCircle(index, characterCount, markerCircleRadius(characterCount));
  return { dx: seat.dx, dy: seat.dy - rise };
}
